<template>
  <b-form-group class="radio-select-input">
    <b-form-text v-if="description" class="text-muted text-justify mt-0 mb-3">
      {{ description }}
    </b-form-text>
    <div class="row" v-for="(chunk, i) in chunkOptions(options, getColumnsNumber(fieldColumns))" :key="i">
      <div v-bind:key="index" v-for="index in getColumnsNumber(fieldColumns)"  class="col-12" :class="[inline && 'col-lg-'+12/getColumnsNumber(fieldColumns)+' mb-2', !inline && 'mb-3']">
        <b-form-radio v-if="chunk[index-1]"
                      v-model="selectedOption"
                      :name="fieldKey"
                      :disabled="disabled"
                      :value="chunk[index-1][valueKey] || chunk[index-1]"
                      size="lg">
          {{ chunk[index-1][textKey] || chunk[index-1] }}
        </b-form-radio>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import {chunkArray} from "@/utils/ChunkArray";

export default {
  name: "RadioSelectInput",
  props: {
    disabled: Boolean,
    fieldKey: String,
    fieldColumns: Number,
    valueKey: String,
    textKey: String,
    description: String,
    value: String,
    options: [Array, Object],
    inline: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectedOption: null,
    }
  },
  methods: {
    chunkOptions(options, chunkSize = 3) {
      return chunkArray(options, chunkSize);
    },
    getColumnsNumber(fieldColumns) {
      if (fieldColumns > 0) {
        return fieldColumns;
      }
      return 3;
    },
  },
  mounted() {
    if (this.value) {
      this.selectedOption = JSON.parse(JSON.stringify(this.value));
    }
  },
  watch: {
    value(newVal) {
      this.selectedOption = newVal
    },
    selectedOption(newVal) {
      this.$emit('input', newVal);
    }
  }
}
</script>

<style scoped>
.radio-select-input >>> .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: var(--accent-color) !important;
}

.radio-select-input >>> .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  border-color: var(--accent-color) !important;
}

.radio-select-input >>> .custom-radio .custom-control-input ~ .custom-control-label::before {
  margin-top: -2px;
}

.radio-select-input >>> .custom-radio .custom-control-input ~ .custom-control-label::after {
  margin-top: -2px;
}

.radio-select-input >>> .custom-radio .custom-control-label::before {
  background-color: unset;
}

.radio-select-input >>> .custom-radio .custom-control-input:disabled:not(:checked) ~ .custom-control-label::before {
  background: #f4f5f8 !important;
}
</style>
